import { defineMessages } from "react-intl";

export const platformMessages = defineMessages({
  dashboard: {
    id: "IaPnJ0",
    defaultMessage: "Dashboard",
    description: "platform name: the full dashboard",
  },
  ops: {
    id: "oN3aIs",
    defaultMessage: "Ops",
    description: "platform name: the operator app (ops subdomain)",
  },
  portal: {
    id: "yod3YU",
    defaultMessage: "Portal",
    description: "platform name: the employee portal",
  },
  dashboardAndOps: {
    id: "oFtnAk",
    defaultMessage: "Dashboard and Ops",
    description: "staff member can sign in to both platforms",
  },
  onlyOps: {
    id: "zZN3Q6",
    defaultMessage: "Ops only",
    description: "staff member can only sign in to the operator app",
  },
  onlyDashboard: {
    id: "bZH5F1",
    defaultMessage: "Dashboard only",
    description: "staff member can only sign in to the dashboard",
  },
  noPlatform: {
    id: "Ca0+cQ",
    defaultMessage: "No access",
    description: "staff member cannot sign in to any platform",
  },
  cardTitle: {
    id: "OkH6os",
    defaultMessage: "Platform access",
    description: "permission group card title",
  },
  cardDescription: {
    id: "zyYP9j",
    defaultMessage:
      "Where members of this group can sign in. What they can do there still depends on the permissions. A member of several groups can use every platform any of them grants.",
    description: "permission group card description",
  },
  dashboardOption: {
    id: "k8BJSg",
    defaultMessage: "Dashboard — full back office",
    description: "checkbox label",
  },
  portalOption: {
    defaultMessage: "Portal — employee portal (time book, vacations, tasks)",
    id: "uHMyvj",
    description: "checkbox label",
  },
  opsOption: {
    id: "0MM380",
    defaultMessage: "Ops — operator app (labels and operations)",
    description: "checkbox label",
  },
  restrictionsTitle: {
    id: "6ZnnJC",
    defaultMessage: "Sign-in restrictions",
    description: "permission group card title",
  },
  restrictionsDescription: {
    id: "7DBn+x",
    defaultMessage:
      "Limit when and where members of this group can sign in. Admins are never restricted. If a person is in several groups, any group that allows it is enough.",
    description: "permission group card description",
  },
  hoursOnly: {
    id: "KzTBYd",
    defaultMessage: "Only while the shop is open (see Opening hours)",
    description: "checkbox label",
  },
  ipRanges: {
    id: "LkiPET",
    defaultMessage: "Allowed IP addresses or ranges",
    description: "textarea label",
  },
  ipRangesHelp: {
    id: "qSG3Ti",
    defaultMessage:
      "One per line, e.g. 203.0.113.7 or 203.0.113.0/24 (use a range if the workplace IP changes). Leave empty to allow any network.",
    description: "textarea helper text",
  },
  ipRangesInvalid: {
    id: "ld6kLB",
    defaultMessage: "One of the IP addresses or ranges is not valid",
    description: "validation error",
  },
  columnTitle: {
    id: "TA5W8f",
    defaultMessage: "Access to",
    description: "staff list column: platforms the member can sign in to",
  },
  inviteGroups: {
    id: "4nZGlm",
    defaultMessage: "Permission groups",
    description: "invite dialog section title",
  },
  inviteGroupsHint: {
    id: "Un3XLr",
    defaultMessage: "The groups decide what the person can do and which platforms they can open.",
    description: "invite dialog section hint",
  },
});
